import React from 'react';
import { CalendarEventEditTemplate } from 'themes/application/schedule/components';
import { observer } from 'mobx-react';
import { CalendarEventEditStore } from 'application/schedule/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new CalendarEventEditStore(rootStore, componentProps), 'eventEditStore')
@observer
class CalendarEventEdit extends React.Component {
    render() {
        return <CalendarEventEditTemplate {...this.props} />
    }
}

export default CalendarEventEdit;